export default __webpack_public_path__ + "static/media/insurance_divider.e7c0bdf2.svg";